class SensenQuickAdd {
  constructor() {
    this.modal = document.getElementById('SensenQuickAddModal');
    this.content = document.getElementById('SensenQuickAddContent');
    if (!this.modal || !this.content) return;

    this.currentProduct = null;
    this.selectedOptions = {};
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-sensen-quick-add]');
      if (btn) {
        e.preventDefault();
        const handle = btn.getAttribute('data-product-handle');
        const form = btn.closest('form');
        const variantInput = form ? form.querySelector('[name="id"]') : null;
        const variantId = variantInput ? variantInput.value : null;
        if (handle) {
          this.open(handle, variantId);
        }
        return;
      }

      if (this.modal.getAttribute('aria-hidden') === 'false') {
        const isCloseBtn = e.target.closest('[data-quick-add-close]') || e.target.closest('.sensen-quick-add-modal__close');
        const isBackdrop = e.target.classList.contains('sensen-quick-add-modal__backdrop') || e.target === this.modal;

        if (isCloseBtn || isBackdrop) {
          this.close();
        }
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    });
  }

  async open(handle, targetVariantId = null) {
    this.modal.setAttribute('aria-hidden', 'false');

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
    document.body.style.overflow = 'hidden';
    this.content.innerHTML = '';

    try {
      const productUrl = `${window.routes.cart_url.replace('/cart', '')}/products/${handle}`;
      const res = await fetch(`${productUrl}?section_id=sensen-quick-add-modal`);
      if (!res.ok) throw new Error('Section fetch failed');

      const htmlText = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const bodyContent = doc.querySelector('.sensen-quick-add-body');

      if (!bodyContent) throw new Error('Invalid section payload');

      this.content.innerHTML = '';
      this.content.appendChild(bodyContent);

      const productJsonEl = bodyContent.querySelector('#SensenQuickAddProductJson');
      if (productJsonEl) {
        this.currentProduct = JSON.parse(productJsonEl.textContent);
        let selectedVariant = null;
        if (targetVariantId) {
          selectedVariant = this.currentProduct.variants.find(v => String(v.id) === String(targetVariantId));
        }
        if (!selectedVariant) {
          selectedVariant = this.currentProduct.variants.find(v => v.available) || this.currentProduct.variants[0];
        }

        this.selectedOptions = {};
        this.currentProduct.options.forEach((opt, idx) => {
          const optName = typeof opt === 'object' ? opt.name : opt;
          this.selectedOptions[optName] = selectedVariant.options[idx];
        });

        // Update active chip classes in DOM
        const chips = this.content.querySelectorAll('.sensen-quick-add-chip');
        chips.forEach(chip => {
          const pos = parseInt(chip.getAttribute('data-option-position'), 10) - 1;
          const val = chip.getAttribute('data-option-value');
          const opt = this.currentProduct.options[pos];
          const optName = typeof opt === 'object' ? opt.name : opt;
          if (this.selectedOptions[optName] === val) {
            chip.classList.add('is-selected');
          } else {
            chip.classList.remove('is-selected');
          }
        });
      }

      this.bindEvents();
      this.updateVariantUI();
    } catch (err) {
      console.error('Quick add fetch error:', err);
    }
  }

  close() {
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  getCurrentVariant() {
    if (!this.currentProduct) return null;
    return this.currentProduct.variants.find(v => {
      return this.currentProduct.options.every((opt, idx) => {
        const optName = typeof opt === 'object' ? opt.name : opt;
        return v.options[idx] === this.selectedOptions[optName];
      });
    }) || null;
  }

  formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  getSizedImageUrl(src, width) {
    try {
      const url = new URL(src);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch {
      return src;
    }
  }

  updateVariantUI() {
    const variant = this.getCurrentVariant();
    if (!variant || !this.currentProduct) return;

    const priceEl = this.content.querySelector('[data-price]');
    const comparePriceEl = this.content.querySelector('[data-compare-price]');
    const submitBtn = this.content.querySelector('#SensenQuickAddSubmit');
    const mediaImg = this.content.querySelector('.sensen-quick-add-media img');

    if (priceEl) {
      priceEl.textContent = this.formatMoney(variant.price);
      const isSale = variant.compare_at_price > variant.price;
      priceEl.classList.toggle('sensen-quick-add-price--sale', isSale);

      if (comparePriceEl) {
        if (isSale) {
          comparePriceEl.textContent = this.formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      const omnibusWrap = this.content.querySelector('[data-omnibus-wrap]');
      const omnibusPrice = this.content.querySelector('[data-omnibus-price]');
      if (omnibusWrap) {
        if (isSale) {
          if (omnibusPrice) omnibusPrice.textContent = this.formatMoney(variant.price);
          omnibusWrap.style.display = '';
        } else {
          omnibusWrap.style.display = 'none';
        }
      }
    }

    if (mediaImg && variant.featured_image) {
      mediaImg.src = this.getSizedImageUrl(variant.featured_image.src, 600);
    }

    if (submitBtn) {
      const submitText = submitBtn.querySelector('span');

      if (variant.available) {
        submitBtn.disabled = false;
        if (submitText) submitText.textContent = submitText.getAttribute('data-text-add') || 'Dodaj do koszyka';
      } else {
        submitBtn.disabled = true;
        if (submitText) submitText.textContent = submitText.getAttribute('data-text-sold') || 'Wyprzedany';
      }
      submitBtn.setAttribute('data-variant-id', variant.id);
    }
  }

  bindEvents() {
    this.content.querySelectorAll('.sensen-quick-add-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        const optionPos = parseInt(chip.getAttribute('data-option-position'), 10);
        const val = chip.getAttribute('data-option-value');
        if (!optionPos || !this.currentProduct) return;

        const rawOpt = this.currentProduct.options[optionPos - 1];
        const optName = typeof rawOpt === 'object' ? rawOpt?.name : rawOpt;
        if (!optName) return;

        this.selectedOptions[optName] = val;

        const group = chip.closest('.sensen-quick-add-option-group');
        if (group) {
          group.querySelectorAll('.sensen-quick-add-chip').forEach(c => c.classList.remove('is-selected'));
          chip.classList.add('is-selected');
        }

        this.updateVariantUI();
      });
    });

    const submitBtn = this.content.querySelector('#SensenQuickAddSubmit');
    if (submitBtn) {
      submitBtn.addEventListener('click', async () => {
        const variantId = submitBtn.getAttribute('data-variant-id');
        if (!variantId) return;

        try {
          const sectionsToFetch = ['cart-icon-bubble'];
          if (document.querySelector('cart-drawer')) {
            sectionsToFetch.push('cart-drawer');
          }
          if (document.querySelector('cart-notification')) {
            sectionsToFetch.push('cart-notification-product', 'cart-notification-button');
          }

          const res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }],
              sections: sectionsToFetch
            })
          });

          if (!res.ok) throw new Error('Cart add failed');
          const data = await res.json();

          const cartCountBadge = document.querySelector('.sensen-header__cart-count-badge');
          if (cartCountBadge) {
            const currentCount = parseInt(cartCountBadge.textContent, 10) || 0;
            const newCount = currentCount + 1;
            cartCountBadge.textContent = newCount;
            cartCountBadge.style.display = '';
          }

          if (window.pubsub && window.PUB_SUB_EVENTS) {
            window.pubsub.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sensen-quick-add', productVariantId: variantId });
          }

          if (window.sensenCartNotification) {
            window.sensenCartNotification.fetchCartAndShow({ productVariantId: variantId });
          }

          this.close();
        } catch (err) {
          console.error('Error adding to cart:', err);
        }
      });
    }
  }
}

const initSensenQuickAdd = () => {
  if (!window.sensenQuickAdd) {
    window.sensenQuickAdd = new SensenQuickAdd();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSensenQuickAdd);
} else {
  initSensenQuickAdd();
}
